import React, { useContext } from 'react';
import { TeApiContext } from '@ecommerce/nest-ssr/common';
import MakeReportForm from 'components/product/product-make-report/components/make-report-form';

import './make-report-modal.scss';

interface MakeCommentModalProps {
    closeMakeCommentModal: () => void;
    onSubmit: (data: { bugName: string[]; }) => void;
}

const MakeReportModal: React.FC<MakeCommentModalProps> = ({ onSubmit, closeMakeCommentModal }) => {
    const api = useContext(TeApiContext);

    if (api === null) {
        throw new Error('Invalid API context');
    }

    return (
        <div className={`make-report-modal-content ${api.getDevice()}`}>
            <div className="make-report-modal-content__header">
                <h2>
                    Zgłoś uwagi do oferty
                </h2>
                <button className="make-report-modal-content__close-button" onClick={closeMakeCommentModal} type="button">
                    <i className="icon-close"/>
                </button>
            </div>
            <MakeReportForm onSubmit={onSubmit}/>
        </div>
    );
};

export default MakeReportModal;
